export default function telephoneMask(value) {
  const regex = /^(\d{2})(\d{4,5})(\d{4})$/g
  if (!regex.test(value)) return value

  return value.replace(regex, '($1) $2-$3')
}
